export default __webpack_public_path__ + "static/media/jordans.9bb9c8ea.PNG";